import { render } from "./SendFeedback.vue?vue&type=template&id=728bd986"
import script from "./SendFeedback.vue?vue&type=script&lang=js"
export * from "./SendFeedback.vue?vue&type=script&lang=js"

import "./SendFeedback.vue?vue&type=style&index=0&id=728bd986&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__